const scriptList = () => import('@/pages/InteractiveScript/ScriptList.vue');
const scriptTemplate = () => import('@/pages/InteractiveScript/ScriptTemplate.vue');
const scriptId = () => import('@/pages/InteractiveScript/_ScriptId.vue');
const scriptTemplateId = () => import('@/pages/InteractiveScript/_ScriptTemplateId.vue');
const scriptTemplateList = () =>
  import('@/pages/InteractiveScript/_ScriptTemplateList.vue');
const edmList = () => import('@/pages/CampaignAsset/EdmList.vue');
const edmId = () => import('@/pages/CampaignAsset/_EdmId.vue');
const smsList = () => import('@/pages/CampaignAsset/SmsList.vue');
const smsId = () => import('@/pages/CampaignAsset/_SmsId.vue');
const marketingActivitiesList = () =>
  import('@/pages/MarketingActivities/MarketingActivitiesList.vue');
const marketingActivitiesId = () =>
  import('@/pages/MarketingActivities/_MarketingActivitiesId.vue');

export default {
  name: 'smartMarketing',
  meta: {
    key: 'smartMarketing',
    hint: 'marketingManagementHint'
  },
  path: '/smart-marketing',
  children: [
    {
      name: 'marketingActivitiesListIndex',
      icon: 'ic_common_activity',
      path: '/smart-marketing/marketing-activities/list',
      meta: {
        permission: ['campaign', 'campaign_asset']
      },
      component: marketingActivitiesList
    },
    {
      name: 'marketingActivitiesId',
      path: '/smart-marketing/marketing-activities/:id',
      meta: {
        hidden: true,
        permission: ['campaign', 'campaign_asset']
      },
      component: marketingActivitiesId
    },
    {
      name: 'interactiveAllScript',
      icon: 'ic_sidemenu_script',
      path: '/smart-marketing/script',
      meta: {
        permission: ['interactive_script']
      },
      redirect: {
        name: 'interactiveAllScriptList'
      },
      children: [
        {
          name: 'interactiveAllScriptIndex',
          path: '/smart-marketing/script/list',
          meta: {
            permission: ['interactive_script']
          },
          children: [
            {
              name: 'interactiveAllScriptList',
              path: '/smart-marketing/script/list',
              meta: {
                permission: ['interactive_script']
              },
              component: scriptList
            },
            {
              name: 'interactiveAllScriptId',
              path: '/smart-marketing/script/list/:id',
              meta: {
                permission: ['interactive_script']
              },
              component: scriptId
            }
          ]
        },
        {
          name: 'interactiveAllScriptTemplate',
          path: '/smart-marketing/script/template',
          meta: {
            permission: ['interactive_script_template']
          },
          redirect: {
            name: 'interactiveAllScriptTemplateCategorie'
          },
          children: [
            {
              name: 'interactiveAllScriptTemplateCategorie',
              path: '/smart-marketing/script/template',
              meta: {
                permission: ['interactive_script_template']
              },
              component: scriptTemplate
            },
            {
              name: 'interactiveAllScriptTemplateId',
              path: '/smart-marketing/script/template/:id',
              meta: {
                permission: ['interactive_script_template']
              },
              component: scriptTemplateList
            },
            {
              name: 'interactiveAllScriptTemplateDemoId',
              path: '/smart-marketing/script/template/:categoryId/demo/:id',
              meta: {
                permission: ['interactive_script_template']
              },
              component: scriptTemplateId
            }
          ]
        }
      ]
    },
    {
      name: 'campaignAsset',
      icon: 'ic_sidemenu_template',
      path: '/smart-marketing/campaign-asset',
      meta: {
        permission: ['campaign_asset']
      },
      redirect: {
        name: 'campaignAssetEdm'
      },
      children: [
        {
          name: 'campaignAssetEdm',
          path: '/smart-marketing/campaign-asset/edm',
          meta: {
            permission: ['campaign_asset']
          },
          redirect: {
            name: 'campaignAssetEdmList'
          },
          children: [
            {
              name: 'campaignAssetEdmList',
              path: '/smart-marketing/campaign-asset/edm/list',
              meta: {
                permission: ['campaign_asset']
              },
              component: edmList
            },
            {
              name: 'campaignAssetEdmId',
              path: '/smart-marketing/campaign-asset/edm/:id',
              meta: {
                permission: ['campaign_asset']
              },
              component: edmId
            }
          ]
        },
        {
          name: 'campaignAssetSms',
          path: '/smart-marketing/campaign-asset/sms',
          meta: {
            permission: ['campaign_asset']
          },
          redirect: {
            name: 'campaignAssetSmsList'
          },
          children: [
            {
              name: 'campaignAssetSmsList',
              path: '/smart-marketing/campaign-asset/sms/list',
              meta: {
                permission: ['campaign_asset']
              },
              component: smsList
            },
            {
              name: 'campaignAssetSmsId',
              path: '/smart-marketing/campaign-asset/sms/:id',
              meta: {
                permission: ['campaign_asset']
              },
              component: smsId
            }
          ]
        }
      ]
    }
  ]
};
